import { render, staticRenderFns } from "./MMainFooter.vue?vue&type=template&id=1334ed86&scoped=true&"
import script from "./MMainFooter.vue?vue&type=script&lang=js&"
export * from "./MMainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MMainFooter.vue?vue&type=style&index=0&id=1334ed86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334ed86",
  null
  
)

export default component.exports